import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './RestaurantsListing.css';
import React, { useState } from 'react';
import { canUseDOM, get, getDictionaryItem, replaceUrlPluses } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import LoadMore from '../DynamicListingComponent/LoadMore';
import getListing from '../../utils/getListing';
import { loadMoreButtonStylesLtr } from '../DynamicListingComponent/DynamicListingComponent';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Filters from './Filters';
import { qsToObject } from '../../utils/querystring';
import { useLocation } from 'react-router-dom';
import { convertQueryParamsToFacetsWithoutPlusReplacement } from './index';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { usePrevious } from '../../utils/usePrevious';
import { convertToAnalyticObject } from '../../utils/analytics';
import { isNil } from '../../utils/IsNil';
import { RestaurantsCard } from '../atoms/RestaurantsCard/RestaurantsCard';
import { checkJssError } from '../../utils/checkJssError';
import InteractiveMapModal from '../atoms/InteractiveMapModal/InteractiveMapModal';
import { splitter } from '../Listing';
import { getInteractiveModalMapConfig } from '../atoms/InteractiveMapModal/utils/getInteractiveModalMapConfig';
var getFacetNamesValue = function getFacetNamesValue(filterData) {
  if (filterData) {
    return filterData.values.map(function (filter) {
      var item1 = get(filter, 'fieldNameItem.item.fieldName.value');
      var item2 = get(filter, 'fieldNameItems.items.0.fieldName.value');
      return item1 || item2;
    });
  } else {
    return [];
  }
};
var createFilterState = function createFilterState(filtersList, location) {
  var qsValues = canUseDOM ? qsToObject(location.search) : {};
  var state = {};
  if (filtersList && filtersList.length) {
    filtersList.forEach(function (filterItem) {
      var fieldName = filterItem.name;
      var fieldTitle = get(filterItem, 'title.jss.value') || filterItem.name;
      var facetName = get(filterItem, 'fieldNameItem.item.fieldName.value');
      var listOfTags = [];
      if (filterItem.tagsToDisplay && filterItem.tagsToDisplay.values && filterItem.tagsToDisplay.values.length) {
        listOfTags = filterItem.tagsToDisplay.values.map(function (tag) {
          return get(tag, 'title.value') || get(tag, 'title.name');
        });
      }
      var preselectedFromQS = qsValues[facetName] ? qsValues[facetName].split(splitter).map(function (value) {
        return replaceUrlPluses(value);
      }).filter(function (value) {
        return listOfTags.includes(value);
      }) : [];
      var preselectedNoDublicates = _toConsumableArray(new Set(_toConsumableArray(preselectedFromQS)));
      state[fieldName] = {
        title: fieldTitle,
        facetName: facetName,
        value: preselectedNoDublicates || []
      };
    });
  }
  return state;
};
export var SORT_QUERY_NAME = 'sortBy';
export var TEXT_SEARCH_FACET_NAME = 'title';
var getDefaultSearchValue = function getDefaultSearchValue(location) {
  return canUseDOM ? replaceUrlPluses(qsToObject(location.search)[TEXT_SEARCH_FACET_NAME]) || '' : '';
};
var getDefaultSortValue = function getDefaultSortValue(location) {
  return canUseDOM ? qsToObject(location.search)[SORT_QUERY_NAME] || '' : '';
};
var RestaurantsListingComponent = function RestaurantsListingComponent(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useSitecoreContext();
  var location = useLocation();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var searchIndexParams = get(params, 'SearchIndex', '');
  var fieldsData = get(fields, 'data', {});
  var messageSearchResultEmpty = get(fieldsData, 'contextItem.messageSearchResultEmpty.value', '');
  var typeArray = get(fields, 'data.listingConfiguration.contentType.types') || [];
  var filterData = get(fields, 'data.listingConfiguration.filters') || [];
  var isTagPage = get(fields, 'data.listingConfiguration.isTagPage.jss.value');
  var filterValue = get(fields, 'data.listingConfiguration.filters.values') || [];
  var pagesize = Number(get(fields, 'data.listingConfiguration.pageSize.jss.value'));
  var dictionary = get(fields, 'data.dictionary');
  var loadMoreText = getDictionaryItem(dictionary, 'LoadMore');
  var viewedNofMLabel = "".concat(getDictionaryItem(dictionary, 'viewedAmount')).replace("{x}", "{#loadedHits#}").replace("{y}", "{#nbHits#}");
  var emptySearchText = getDictionaryItem(dictionary, 'NoResultFound') || '';
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    result = _React$useState2[0],
    setResult = _React$useState2[1];
  var _React$useState3 = React.useState({}),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    facets = _React$useState4[0],
    setFacets = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    hits = _React$useState6[0],
    setHits = _React$useState6[1];
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    page = _React$useState8[0],
    setpage = _React$useState8[1];
  var _React$useState9 = React.useState(true),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    firstRendering = _React$useState10[0],
    setFirstRendering = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    loading = _React$useState12[0],
    setLoading = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    buttonPressed = _React$useState14[0],
    setButtonPressed = _React$useState14[1];
  var _useState = useState(function () {
      return getDefaultSearchValue(location);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    searchTextValue = _useState2[0],
    setSearchTextValue = _useState2[1];
  var _useState3 = useState(function () {
      return getDefaultSortValue(location);
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    sortingValue = _useState4[0],
    setSortingValue = _useState4[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    resetFilter = _React$useState16[0],
    setResetFilter = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    resetAllFilters = _React$useState18[0],
    setResetAllFilters = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    setFilters = _React$useState20[0],
    applySetFilters = _React$useState20[1];
  var _React$useState21 = React.useState([]),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    currentTypes = _React$useState22[0],
    applycurrentTypes = _React$useState22[1];
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState23 = React.useState(true),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    isVdsite = _React$useState24[0],
    setIsVdsite = _React$useState24[1];
  var isFirstLoadWithoutFacets = React.useRef(false);
  var mapConfigurationЫSource = get(fields, 'data.listingConfiguration.mapConfiguration');
  var mapConfiguration = mapConfigurationЫSource ? mapConfigurationЫSource[0] : [];
  var mapModalTitle = get(mapConfiguration, 'title.jss.value') || '';
  var mapModalContentType = get(fields, 'data.listingConfiguration.contentType.types[0].template.targetItem.value') || '';
  var mapModalDefaultMapZoom = Number(get(mapConfiguration, 'defaultMapZoom.jss.value')) || 10;
  var mapModalCentreMapLatitude = Number(get(mapConfiguration, 'centreMapLatitude.jss.value')) || 25.2048493;
  var mapModalCentreMapLongitude = Number(get(mapConfiguration, 'centreMapLongitude.jss.value')) || 55.2707828;
  var mapModalColor = get(mapConfiguration, 'colourTheme.item.backgroundColor.jss.value') || 'var(--main-color)';
  var withMapModalView = getInteractiveModalMapConfig(mapConfiguration);
  var maxPageSize = 1000;
  var mapDictionary = get(fields, 'data.mapDictionary');
  var _React$useState25 = React.useState([]),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    allHits = _React$useState26[0],
    setAllHits = _React$useState26[1];
  var _useState5 = useState(function () {
      return createFilterState(filterData.values, location);
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    filterState = _useState6[0],
    _setFilterState = _useState6[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var queryParams = qsToObject(location.search);
  if (Object.keys(queryParams).length !== 0) {
    for (var key in queryParams) {
      queryParams[key] = replaceUrlPluses(queryParams[key], key === 'tags' || key === 'itineraryDatesRange') || queryParams[key];
    }
  }
  var facetFilters = convertQueryParamsToFacetsWithoutPlusReplacement(queryParams, true, filterData);
  var concatFilters = function () {
    return facetFilters.reduce(function (acc, filter) {
      var validFilter = filter.reduce(function (filterAcc, filterEl) {
        filterAcc.push(filterEl);
        return filterAcc;
      }, []);
      acc = acc.concat(validFilter);
      return acc;
    }, []);
  }();
  var prevFacetFilters = usePrevious(facetFilters);
  var prevPage = usePrevious(page);
  React.useEffect(function () {
    var algoliaIndexes = sortingValue ? "".concat(get(params, 'SearchIndex'), "_").concat(sortingValue) : get(params, 'SearchIndex');
    var types = typeArray.map(function (type) {
      var value = type && type.template.targetItem.value;
      return "type:".concat(value);
    });
    applycurrentTypes(types);
    var facetNames = getFacetNamesValue(filterData);
    var isLoadedFeatureItem = firstRendering && types.length == 1 && types[0] == 'type:Event';
    var itemFilters = {
      query: searchTextValue,
      facets: _toConsumableArray(facetNames),
      facetFilters: [].concat(_toConsumableArray(types), _toConsumableArray(concatFilters)),
      hitsPerPage: isLoadedFeatureItem ? pagesize + 1 : pagesize,
      page: page
    };
    var allItemFilters = {
      query: searchTextValue,
      facets: _toConsumableArray(facetNames),
      facetFilters: [].concat(_toConsumableArray(types), _toConsumableArray(concatFilters)),
      hitsPerPage: maxPageSize,
      page: 0
    };
    var listingRequestAllItems = function listingRequestAllItems() {
      setLoading(true);
      var promisesQueue = [];
      var finalResponse = [];
      var pageNumber = 1;
      getListing(algoliaIndexes, allItemFilters).then(function (response) {
        if (response.hits) {
          applySetFilters(false);
          finalResponse = _toConsumableArray(response.hits);
          finalResponse = finalResponse.filter(function (el) {
            return el._geoloc && el.objectID;
          });
          setAllHits(finalResponse);

          // nbPages - max available items per page
          if (pageNumber < response.nbPages) {
            // create array of promisses
            for (var i = 1; i < response.nbPages; i++) {
              var itemFilterCopy = _objectSpread({}, allItemFilters);
              itemFilterCopy.page = i;
              promisesQueue.push(itemFilterCopy);
            }
            if (promisesQueue.length) {
              Promise.all(promisesQueue.map(function (item) {
                getListing(algoliaIndexes, item).then(function (responses) {
                  // summarize all the hits by all request
                  finalResponse = [].concat(_toConsumableArray(finalResponse), _toConsumableArray(responses.hits));
                  finalResponse = finalResponse.filter(function (el) {
                    return el._geoloc && el.objectID;
                  });
                }).then(function () {
                  setAllHits(finalResponse);
                  setTimeout(function () {
                    return setLoading(false);
                  }, 1000);
                }).catch(function (error) {
                  console.log(error);
                });
              }));
            }
          }
        }
      }).then(function () {
        setTimeout(function () {
          return setLoading(false);
        }, 1000);
        setResetAllFilters(false);
      });
    };
    var listingRequest = function listingRequest() {
      setLoading(true);
      getListing(algoliaIndexes, itemFilters).then(function (response) {
        setFacets(response.facets);
        setResult(response);
        applySetFilters(false);
        if (response.hits.length) {
          if (buttonPressed) {
            setButtonPressed(false);
            var resultsBlocks = document.querySelectorAll('.results');
            if (resultsBlocks.length) {
              var lastResultsBlock = resultsBlocks[resultsBlocks.length - 1];
              var focusableList = lastResultsBlock.querySelectorAll('a, button, [tabindex="0"]');
              if (focusableList.length) {
                var lastFocusable = focusableList[focusableList.length - 1];
                lastFocusable.focus();
              }
            }
          }
          setHits(hits.concat(response.hits[0].featured && isLoadedFeatureItem && response.nbPages > 1 ? response.hits.splice(0, response.hits.length - 1) : response.hits));
        }
        setTimeout(function () {
          if (canUseDOM) {
            window.onscroll = function () {};
          }
        }, 100);
        setLoading(false);
        setFirstRendering(false);
        setResetAllFilters(false);
      });
    };
    if (resetAllFilters) {
      listingRequest();
      if (withMapModalView) {
        listingRequestAllItems();
      }
    } else if (setFilters) {
      listingRequest();
      if (withMapModalView) {
        listingRequestAllItems();
      }
    } else {
      if (!isFirstLoadWithoutFacets.current) {
        // compare previous facet filters value to escape extra request

        if (prevFacetFilters && prevFacetFilters.length === 0) {
          prevFacetFilters = undefined;
        }
        if (JSON.stringify(facetFilters) !== JSON.stringify(prevFacetFilters) || page !== prevPage) {
          listingRequest();
          if (withMapModalView) {
            listingRequestAllItems();
          }
        }
      } else {
        isFirstLoadWithoutFacets.current = false;
      }
    }
  }, [resetFilter, setFilters, page, buttonPressed, resetAllFilters]);
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var loadMoreAnalyticsClick = function loadMoreAnalyticsClick(text) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['LoadMoreAnalytics'], params), text);
  };
  var loadMore = function loadMore() {
    if (canUseDOM) {
      window.onscroll = function () {
        window.scrollTo(window.scrollX, window.scrollY);
      };
    }
    setButtonPressed(true);
    setpage(function (prevState) {
      return prevState + 1;
    });
    loadMoreAnalyticsClick(loadMoreText);
  };
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.listingConfiguration)) {
    console.warn('RestaurantsListing component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[RestaurantsListing component is empty: please provide datasource]");
    }
    return null;
  }
  var nbHits = result ? result.nbHits : 0;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    componentTabIndex: "disabled"
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "Listing"
  }, filterValue && filterValue.length >= 1 && /*#__PURE__*/React.createElement(Filters, {
    params: params,
    fields: fields,
    setpage: setpage,
    setHits: setHits,
    facets: facets,
    applySetFilters: applySetFilters,
    rtl: rtl,
    searchTextValue: searchTextValue,
    setSearchTextValue: setSearchTextValue,
    sortingValue: sortingValue,
    setSortingValue: setSortingValue,
    nbHits: nbHits,
    filterState: filterState,
    setFilterState: function setFilterState(newValue) {
      return _setFilterState(newValue);
    }
  }), loading && /*#__PURE__*/React.createElement("div", {
    className: "Listing Listing--loader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loader-t1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loadingio-spinner-rolling-arlp0sgzkfu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ldio-fryp34cx4ij"
  }, /*#__PURE__*/React.createElement("div", null))))), /*#__PURE__*/React.createElement(React.Fragment, null, currentTypes.map(function (type, index) {
    if (type === 'type:Restaurant' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Restaurant')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xl-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row restaurantsListingRowGap"
      }, !loading && !hits.length && /*#__PURE__*/React.createElement("h4", {
        className: "empty-results",
        dangerouslySetInnerHTML: {
          __html: emptySearchText
        }
      }), hits && hits.map(function (hit, index) {
        if (hit.type.indexOf('Restaurant') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4",
            style: {
              display: "flex"
            },
            key: index
          }, /*#__PURE__*/React.createElement(RestaurantsCard, {
            analyticsCallback: eventsAnalytics,
            item: hit,
            params: params,
            reviews: getDictionaryItem(dictionary, 'reviews') || '',
            rtl: rtl,
            textToHighlight: searchTextValue
          }));
        }
      }))))));
    }
  }), !loading && !hits.length && /*#__PURE__*/React.createElement("div", {
    className: "load-more"
  }, /*#__PURE__*/React.createElement("div", {
    className: "message-search-result-empty"
  }, messageSearchResultEmpty)), result && result.nbPages - 1 > result.page && /*#__PURE__*/React.createElement(LoadMore, {
    buttonLabel: loadMoreText,
    onClick: loadMore,
    nbHits: result.nbHits,
    loadedHits: (page + 1) * pagesize,
    viewedNofMLabel: viewedNofMLabel
  }))), withMapModalView && /*#__PURE__*/React.createElement(InteractiveMapModal, {
    loading: loading,
    params: params,
    hits: allHits,
    mainHitsPerPage: "".concat(pagesize),
    mainTitle: mapModalTitle,
    contentType: mapModalContentType,
    defaultMapZoom: mapModalDefaultMapZoom,
    centreMapLatitude: mapModalCentreMapLatitude,
    centreMapLongitude: mapModalCentreMapLongitude,
    mapModalColor: mapModalColor,
    dictionary: mapDictionary,
    eventsAnalytics: eventsAnalytics,
    filtersComponent: filterValue && filterValue.length >= 1 ? /*#__PURE__*/React.createElement(Filters, {
      params: params,
      fields: fields,
      setpage: setpage,
      setHits: setHits,
      facets: facets,
      applySetFilters: applySetFilters,
      rtl: rtl,
      searchTextValue: searchTextValue,
      setSearchTextValue: setSearchTextValue,
      sortingValue: sortingValue,
      setSortingValue: setSortingValue,
      nbHits: nbHits,
      withMapModalView: true,
      filterState: filterState,
      setFilterState: function setFilterState(newValue) {
        return _setFilterState(newValue);
      }
    }) : /*#__PURE__*/React.createElement(React.Fragment, null)
  })));
};
var RestaurantsListing = function RestaurantsListing(props) {
  return checkJssError(props, RestaurantsListingComponent);
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(poiStyle, " ").concat(loadMoreButtonStylesLtr, " ").concat(commonStyles, "\n     ").concat(rtl ? stylesRTL : stylesLTR, " ")
  }, children);
};
export var commonStyles = "c1wh5elx";
export var poiStyle = "pkdxjib";
export var stylesLTR = "skagn3h";
export var stylesRTL = "s1y0cr32";
export default RestaurantsListing;